export const MAX_ADWATCHES_ERROR = 'error_max_saved_adwatches_reached'
export const MAX_SAVED_ADS_ERROR = 'error_max_saved_ads_reached'
